/** Aufrufe fuer die Festlegung eigener Felder. */

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';

export type CustomFieldDefinition = components['schemas']['CustomFieldDefinitionRead'];
export type CustomFieldObjectType = components['schemas']['CustomFieldObjectType'];
export type CustomFieldType = components['schemas']['CustomFieldType'];

export function listCustomFields(
  objectType?: CustomFieldObjectType,
  onlyActive = false,
): Promise<CustomFieldDefinition[]> {
  return request<CustomFieldDefinition[]>('/custom-fields', {
    query: { object_type: objectType, only_active: onlyActive ? 'true' : undefined },
  });
}

export function createCustomField(
  payload: Record<string, unknown>,
): Promise<CustomFieldDefinition> {
  return request<CustomFieldDefinition>('/custom-fields', { method: 'POST', body: payload });
}

export function updateCustomField(
  id: string,
  payload: Record<string, unknown>,
): Promise<CustomFieldDefinition> {
  return request<CustomFieldDefinition>(`/custom-fields/${id}`, { method: 'PATCH', body: payload });
}

export function deleteCustomField(id: string): Promise<undefined> {
  return request<undefined>(`/custom-fields/${id}`, { method: 'DELETE' });
}

/**
 * Bisher erfasste Werte eines eigenen Textfelds -- haeufigste zuerst.
 *
 * Nur fuer Bearbeiter; der Server antwortet einem Portalnutzer mit 403.
 */
export function suggestCustomFieldValues(definitionId: string, q: string): Promise<string[]> {
  return request<string[]>(`/custom-fields/${definitionId}/value-suggestions`, { query: { q } });
}
